export const tipLists = [
  {
    link: 'https://smiledragon.notion.site/1f2d07302a2281c8b689da1b9e02041a',
    title: '계정 오류를 줄이는 꿀팁',
  },
  {
    link: 'https://smiledragon.notion.site/1f2d07302a2281469ecde01f9c84d4fb',
    title: '더 많이 포인트를 적립하는 꿀팁',
  },
  {
    link: 'https://smiledragon.notion.site/1f2d07302a2281c6bd3de5282c9c0145',
    title: '인스타그램 계정 활성화하는 꿀팁',
  },
];
